// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ZulassungRouteImport } from './routes/zulassung'
import { Route as WissenschaftRouteImport } from './routes/wissenschaft'
import { Route as VergleichRouteImport } from './routes/vergleich'
import { Route as UeberUnsRouteImport } from './routes/ueber-uns'
import { Route as ThailandRouteImport } from './routes/thailand'
import { Route as StudienRouteImport } from './routes/studien'
import { Route as SicherheitRouteImport } from './routes/sicherheit'
import { Route as RetaVsOzempicRouteImport } from './routes/reta-vs-ozempic'
import { Route as RechnerRouteImport } from './routes/rechner'
import { Route as PromisRouteImport } from './routes/promis'
import { Route as NebenwirkungenRouteImport } from './routes/nebenwirkungen'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as IndexRouteImport } from './routes/index'

const ZulassungRoute = ZulassungRouteImport.update({
            id: '/zulassung',path: '/zulassung',getParentRoute: () => rootRouteImport
          })
const WissenschaftRoute = WissenschaftRouteImport.update({
            id: '/wissenschaft',path: '/wissenschaft',getParentRoute: () => rootRouteImport
          })
const VergleichRoute = VergleichRouteImport.update({
            id: '/vergleich',path: '/vergleich',getParentRoute: () => rootRouteImport
          })
const UeberUnsRoute = UeberUnsRouteImport.update({
            id: '/ueber-uns',path: '/ueber-uns',getParentRoute: () => rootRouteImport
          })
const ThailandRoute = ThailandRouteImport.update({
            id: '/thailand',path: '/thailand',getParentRoute: () => rootRouteImport
          })
const StudienRoute = StudienRouteImport.update({
            id: '/studien',path: '/studien',getParentRoute: () => rootRouteImport
          })
const SicherheitRoute = SicherheitRouteImport.update({
            id: '/sicherheit',path: '/sicherheit',getParentRoute: () => rootRouteImport
          })
const RetaVsOzempicRoute = RetaVsOzempicRouteImport.update({
            id: '/reta-vs-ozempic',path: '/reta-vs-ozempic',getParentRoute: () => rootRouteImport
          })
const RechnerRoute = RechnerRouteImport.update({
            id: '/rechner',path: '/rechner',getParentRoute: () => rootRouteImport
          })
const PromisRoute = PromisRouteImport.update({
            id: '/promis',path: '/promis',getParentRoute: () => rootRouteImport
          })
const NebenwirkungenRoute = NebenwirkungenRouteImport.update({
            id: '/nebenwirkungen',path: '/nebenwirkungen',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,FaqRoute: FaqRoute,KontaktRoute: KontaktRoute,NebenwirkungenRoute: NebenwirkungenRoute,PromisRoute: PromisRoute,RechnerRoute: RechnerRoute,RetaVsOzempicRoute: RetaVsOzempicRoute,SicherheitRoute: SicherheitRoute,StudienRoute: StudienRoute,ThailandRoute: ThailandRoute,UeberUnsRoute: UeberUnsRoute,VergleichRoute: VergleichRoute,WissenschaftRoute: WissenschaftRoute,ZulassungRoute: ZulassungRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)